import { Auth, API } from 'aws-amplify';

export type UserAttribute = {
  Name: string;
  Value: string;
};

// ユーザー作成
export const createUser = async (
  username: string,
  userAttributes?: UserAttribute[]
) => {
  const apiName = 'AdminQueries';
  const path = '/createUser';
  const params = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getAccessToken()
        .getJwtToken()}`,
    },
    body: {
      username,
      userAttributes,
    },
  };
  return await API.post(apiName, path, params);
};

// グループにユーザー追加
export const addUserToGroup = async (
  username: string,
  groupname: string
) => {
  const apiName = 'AdminQueries';
  const path = '/addUserToGroup';
  const params = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getAccessToken()
        .getJwtToken()}`,
    },
    body: {
      username,
      groupname,
    },
  };
  return await API.post(apiName, path, params);
};

// ユーザー削除
export const deleteUser = async (username: string) => {
  const apiName = 'AdminQueries';
  const path = '/deleteUser';
  const params = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getAccessToken()
        .getJwtToken()}`,
    },
    body: {
      username,
    },
  };
  return await API.post(apiName, path, params);
};
